
import {DemoCard} from "../DemoCard/DemoCard";
import './TryGame.scss'
import React from 'react'

export const TryGame = () => {
    return (
        <div className="relative sm:py-5 mt-40">
            <div aria-hidden="true" className="hidden sm:block">
                <div className="absolute inset-y-0 left-0 w-1/2 bg-gray-50 rounded-r-3xl" />
                <svg className="absolute top-8 left-1/2 -ml-3" width={404} height={392} fill="none" viewBox="0 0 404 392">
                    <defs>
                        <pattern
                            id="8228f071-bcee-4ec8-905a-2a059a2cc4fb"
                            x={0}
                            y={0}
                            width={20}
                            height={20}
                            patternUnits="userSpaceOnUse"
                        >
                            <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width={404} height={392} fill="url(#8228f071-bcee-4ec8-905a-2a059a2cc4fb)" />
                </svg>
            </div>
            <div className="mx-auto max-w-md px-2  sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
                <div className="relative rounded-2xl px-6 light-theme  overflow-hidden shadow-xl sm:px-30 sm:py-20">
                    <div aria-hidden="true" className="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0">
                        <svg
                            className="absolute inset-0 h-full w-full"
                            preserveAspectRatio="xMidYMid slice"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 1463 360"
                        >
                            <path
                                className="text-blue-200 text-opacity-40"
                                fill="currentColor"
                                d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
                            />
                            <path
                                className="text-blue-100 text-opacity-40"
                                fill="currentColor"
                                d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
                            />
                        </svg>
                    </div>
                    <div className="demo-section">
                        <div className=" max-w-7xl mx-auto px-2 sm:mb-10">
                            <div className="text-center my-10 sm:my-8 lg:my-0">
                                <p className="text-3xl  font-extrabold text-white sm:text-5xl sm:tracking-tight lg:text-5xl">
                                    Know your team better
                                </p>
                                <p className="max-w-xl mt-5 mx-auto text-xl text-white">
                                    Let's see how much you know about your favourite team
                                </p>
                            </div>
                        </div>

                        <div className="demo-card-s">
                            <DemoCard />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
